import { ReactNode } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { cn } from 'utils/style-utils';
import { useDrawerResize } from './useDrawerResize';

interface DrawerPanelProps {
  isOpen: boolean;
  content: ReactNode;
  isSplitView?: boolean;
}

export const DrawerPanel = ({
  isOpen,
  content,
  isSplitView = false,
}: DrawerPanelProps) => {
  const { drawerWidth, isResizingDrawer, handleDrawerResizeStart } =
    useDrawerResize();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="modal"
          initial={{ width: 0 }}
          animate={{ width: isSplitView ? '50%' : drawerWidth }}
          exit={{ width: 0 }}
          transition={isResizingDrawer ? { duration: 0 } : undefined}
          className="fixed right-0 top-0 bottom-0 bg-white z-50 flex"
        >
          {!isSplitView && (
            <div
              role="separator"
              aria-orientation="vertical"
              aria-label="Resize drawer"
              onMouseDown={handleDrawerResizeStart}
              className={cn(
                'w-1 shrink-0 cursor-col-resize hover:bg-primary-300',
                isResizingDrawer && 'bg-primary-400',
              )}
            />
          )}
          <div className="min-w-0 flex-1 flex">{content}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
